const tabbedSelect = (select, targetWrapper, tabBaseClass = '.tabbed-select') => {
    const wrapper = $(targetWrapper);
    const activeClass = 'is-active';
    const onSelect = (e) => {
        const val = $(e.target).val();//.replace(/[^a-z]/gi, '_').replace(/[_]{2,}/, '_').toLowerCase();

        console.log(val);
        $('[data-tabbed-select-target]', wrapper).removeClass(activeClass);
        $(tabBaseClass, wrapper).removeClass(activeClass);

        if (!val) {
            return;
        }

        const target = $(`#${ val }${ tabBaseClass }`, wrapper);
        const advancedTarget = $('[data-tabbed-select-target]', wrapper)
            .filter((i, t) => $(t).data('tabbedSelectTarget').indexOf(val) !== -1)

        $(target).addClass(activeClass);

        if (advancedTarget.length) {
            console.log(advancedTarget, val);
            advancedTarget.addClass(activeClass)
        }
    };

    $(document).on('change', select, onSelect).trigger('change');
}

export default tabbedSelect;